import { gql } from '@apollo/client'

import { FileFragment } from './FileFragment'
import { FileMetadataFragment } from './FileMetadataFragment'

export const DesignQuoteFragment = gql`
  ${FileMetadataFragment}
  fragment DesignQuote on DesignQuote {
    id
    type
    createdAt
    updatedAt
    publishedAt
    title
    comment
    price
    approved
    panoramic
    storeId
    mainImage {
      ...FileMetadata
    }
    images {
      ...FileMetadata
    }
    quotations {
      ...FileMetadata
    }
    floorPlans {
      ...FileMetadata
    }
  }
`

export const DesignQuoteWithStoreFragment = gql`
  ${FileMetadataFragment}
  fragment DesignQuoteWithStore on DesignQuote {
    id
    type
    createdAt
    updatedAt
    publishedAt
    title
    comment
    price
    approved
    panoramic
    storeId
    mainImage {
      ...FileMetadata
    }
    images {
      ...FileMetadata
    }
    quotations {
      ...FileMetadata
    }
    floorPlans {
      ...FileMetadata
    }
    store {
      id
      storeName
      phoneNumber
      address
      email
    }
    expirationDate
    latestVersion {
      versionNumber
      createdAt
      staffMemberId
      versionLabel
      changeDescription
      title
      price
      imageCount
      quotationCount
      floorPlanCount
      panoramic
      comment
      mainImage {
        ...FileMetadata
        __typename
      }
      images {
        ...FileMetadata
        __typename
      }
      quotations {
        ...FileMetadata
        __typename
      }
      floorPlans {
        ...FileMetadata
        __typename
      }
    }
    versions {
      versionNumber
      createdAt
      staffMemberId
      changeDescription
      title
      price
      imageCount
      quotationCount
      floorPlanCount
      panoramic
      comment
      mainImage {
        ...FileMetadata
        __typename
      }
      images {
        ...FileMetadata
        __typename
      }
      quotations {
        ...FileMetadata
        __typename
      }
      floorPlans {
        ...FileMetadata
        __typename
      }
    }
  }
`

const QuoteFileFragment = gql`
  fragment QuoteFile on QuoteFile {
    fileType
    fileName
    fileDescription
    url
    name
    price
    validUntil
    uploaded
    version
  }
`

export const MarbodalQuoteFragment = gql`
  ${FileFragment}
  ${QuoteFileFragment}
  fragment MarbodalQuote on MarbodalQuote {
    id
    quoteFile {
      ...QuoteFile
    }
    quoteHistory {
      ...QuoteFile
    }
    image {
      ...File
    }
    images {
      ...File
    }
    drawings {
      ...File
    }
  }
`
